import { LEARNING_FEATURE_FLAGS, readEnvVariable } from '@repo/config';

export function areEnglishIqV2SocialAssetsEnabled(): boolean {
  return readEnvVariable(LEARNING_FEATURE_FLAGS.englishIqV2SocialAssets) === 'true';
}
